// src/components/ProjectSelector.js
import React from 'react';
import { API_BASE_URL } from '../config/api';
import './ProjectSelector.css';

const ProjectSelector = ({ projectPath, setProjectPath, onClose, onSave }) => {
  const handleOpenProject = async () => {
    if (projectPath.trim()) {
      try {
        await fetch('http://localhost:3007/api/open-project', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ projectName: projectPath.trim() })
        });
      } catch (err) {
        console.error('Failed to open project:', err);
      }
    }
  };

  return (
    <div className="project-selector-panel">
      <div className="project-selector-header">
        <h3>Select Project</h3>
        <button className="close-project-btn" onClick={onClose}>×</button>
      </div>
      <div className="project-input">
        <input
          type="text"
          value={projectPath}
          onChange={(e) => setProjectPath(e.target.value)}
          placeholder="Enter project path (e.g., my-project)"
          className="project-path-input"
        />
        <div style={{ display: 'flex', gap: '8px' }}>
          <button 
            className="load-project-btn" 
            onClick={() => onSave(projectPath.trim())}
            disabled={!projectPath.trim()}
          >
            Save & Load Project
          </button>
          <button 
            className="load-project-btn"
            onClick={handleOpenProject}
            disabled={!projectPath.trim()}
            title="Open Project in Explorer"
          >
            Open Folder
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectSelector;